import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import Text from '../components/atoms/Text'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getUserInfo } from '../api/home'
import TutorialOverlay from '../components/molecules/auth/TutorialOverlay'
import { useTutorial } from '../hooks/useTutorial'
import { tutorialPageKeys } from '../data/tutorialConfig'
import { tutorialImages } from '../data/tutorialImages'
import WeeklyActivity from '../components/molecules/WeeklyActivity'
import RecordGroup from '../components/molecules/RecordGroup'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { logEvent } from '../utils/eventLogger'

const Wrapper = styled.div`
  padding: 20px;
  text-align: left;
`
const TopArea = styled.div`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
`
const Logo = styled.p`
  font-family: Cafe24Decobox;
  font-size: 28px;
  margin: 0;
  line-height: 40px;
`
const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin-right: -10px;
`
const MypageIcon = styled(PersonOutlinedIcon)`
  color: ${(props) => props.theme.colors.text.normal};
`
const Message = styled.div`
  margin-bottom: 28px;
  display: flex;
  flex-direction: column;
  gap: 4px;
` 

const Home = () => {
  // 튜토리얼 훅
  const page = tutorialPageKeys.HOME;
  const { show, complete } = useTutorial(page);
  const datas = tutorialImages.HOME.steps;

  const [isLoading, setIsLoading] = useState(true)
  const [userInfo, setUserInfo] = useState({})

  useEffect(() => {
    const fetchUserInfo = async() => {
      try {
        const rlt = await getUserInfo();
        setUserInfo(rlt)
        // console.log(userInfo)
      } catch (err) {
        console.error(err);
        // console.log(err)
      } finally {
        setIsLoading(false)
      }
    }
    fetchUserInfo()
  }, [])

  const navigate = useNavigate();
  
  const isServiceLocked = !userInfo?.isChildRegistered || !userInfo?.isVoiceRegistered
  
  const EVENT_MAP = {
    '/words/new': 'word_register_start',
    '/card-word': 'card_register_start',
    '/conversation-word': 'recording_start'
  };

  const handleMenuClick = (link) => {
    if (isServiceLocked) {
      if (!userInfo?.isChildRegistered) {
        alert('아이를 등록해주세요')
        return
    }
      if (!userInfo?.isVoiceRegistered) {
        alert('아이 음성을 등록해주세요')
        return
      }
    }

    // 로그 기록
    const eventName = EVENT_MAP[link];
    
    if (eventName) {
      logEvent(eventName);
    }

    navigate(link)
  }

  // 아이 이름 뒤 조사 '이' 추가 함수
  const getPostfixI = (name) => {
    if (!name) return '';
    const lastChar = name[name.length - 1];
    const code = lastChar.charCodeAt(0) - 0xac00;
    return code % 28 !== 0 ? '이' : '';
  };

  const childName = `${userInfo.childName}${getPostfixI(userInfo.childName)}`;

  return (
    <DefaultLayout
      bgColor="gray"
      hasNavBar={true}
    >
      <Wrapper>
        <TopArea>
          <Logo>
            Tickle Talk
          </Logo>
          <IconButton
            onClick={() => navigate('/mypage')}>
            <MypageIcon sx={{ fontSize: 28 }}/>
          </IconButton>
        </TopArea>
        <Message>
          {isLoading ? (
            <>
              <Text variant="headline3" weight="medium">&nbsp;</Text>
              <Text variant="headline3" weight="medium">&nbsp;</Text>
            </>
          ) : (
            <>
              <Text variant="headline2" weight="medium">
                안녕하세요. {userInfo.userName}님
              </Text>
              {userInfo.childId ? (
                <Text variant="body1" weight="regular">
                  오늘도 {childName}의 말을 차곡차곡 모아보세요.
                </Text>
              ) : (
                <Text variant="body1" weight="regular">
                  아이를 등록하고 소통을 기록해보세요.
                </Text>
              )}
            </>
          )}
        </Message>
        {!isLoading &&
          <WeeklyActivity 
            weeklyDatas={userInfo}
            defaultSelectedDay={userInfo.currentDate}/>
        }
        <RecordGroup onMenuClick={handleMenuClick}/>
      </Wrapper>
      {show && <TutorialOverlay datas={datas} onClose={complete} />}
    </DefaultLayout>
  )
}

export default Home
